/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var People1XIcon16Solid = forwardRef('People1XIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M11.5 4.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z" }),
        React.createElement("path", { d: "M8.194 9.001 8 9c-1.765 0-5.143.24-5.863 3.607C1.975 13.363 2.627 14 3.4 14h4.396c.097-.53.35-1.035.76-1.444l.055-.056-.056-.056a2.75 2.75 0 0 1-.361-3.443Z" }),
        React.createElement("path", { d: "M11.207 9.793a1 1 0 0 0-1.414 1.414l1.293 1.293-1.293 1.293a1 1 0 1 0 1.414 1.414l1.293-1.293 1.293 1.293a1 1 0 0 0 1.414-1.414L13.914 12.5l1.293-1.293a1 1 0 0 0-1.414-1.414L12.5 11.086l-1.293-1.293Z" })));
});
